module.exports = __webpack_public_path__ + "778a10c6cdd80c6618d65a3fb07d88ec.pdf";